import { clsx } from "clsx";
import { type PropsWithChildren } from "react";

export type LandingButtonProps = PropsWithChildren & {
  onClick: () => void;
  className?: string;
};

export const LandingButton = ({
  children,
  onClick,
  className
}: LandingButtonProps) => {
  return (
    <button
      type="button"
      className={clsx(
        "size-full h-96 rounded-3xl bg-kiosk-landing-button-background px-16 text-kiosk-landing-button-text",
        className
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
